module.exports = __webpack_public_path__ + "img/d200911-2.b9616386.jpg";